(function () {
  'use strict';

  if (window.__tangibleQuickAddSizeRequiredV2) return;
  window.__tangibleQuickAddSizeRequiredV2 = true;

  var patchedApi = null;

  function productHandle(trigger) {
    if (!trigger) return '';
    if (trigger.dataset.productHandle) return trigger.dataset.productHandle;
    var card = trigger.closest('.product-item');
    var link = card && card.querySelector('.card-link, .card-title, .card__heading a');
    var match = (link && link.getAttribute('href') || '').match(/\/products\/([^?#/]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function requireChooser(trigger) {
    var handle = productHandle(trigger);
    if (!handle) return;
    trigger.dataset.productHandle = handle;
    trigger.removeAttribute('data-variant-id');
    delete trigger.dataset.variantId;
  }

  function normaliseTriggers(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.tangible-qa-v2__trigger').forEach(requireChooser);
    if (scope.matches && scope.matches('.tangible-qa-v2__trigger')) requireChooser(scope);
  }

  function enableUnselectedAdd() {
    var modal = document.querySelector('.tangible-qa-v2-modal[aria-hidden="false"]');
    if (!modal) return;
    var add = modal.querySelector('[data-tangible-qa-add]');
    var available = modal.querySelector('.tangible-qa-v2-modal__variant:not(:disabled)');
    var selected = modal.querySelector('.tangible-qa-v2-modal__variant.is-selected');
    var status = modal.querySelector('[data-tangible-qa-status]');
    if (add && available && !selected && !add.classList.contains('is-loading')) add.disabled = false;
    if (status && /please select a size first\.?/i.test(status.textContent || '')) {
      status.textContent = 'Please select a size to continue.';
    }
  }

  function patchApi() {
    var api = window.TangibleQuickAddV3;
    if (!api || api === patchedApi || typeof api.handleTrigger !== 'function') return;

    var original = api.handleTrigger;
    api.handleTrigger = async function (trigger) {
      requireChooser(trigger);
      var result = await original.call(api, trigger);
      requestAnimationFrame(enableUnselectedAdd);
      window.setTimeout(enableUnselectedAdd, 40);
      return result;
    };
    api.__tangibleSizeRequiredV2 = true;
    patchedApi = api;
  }

  function run(root) {
    patchApi();
    normaliseTriggers(root || document);
    enableUnselectedAdd();
  }

  function start() {
    run(document);
  }

  document.addEventListener('shopify:section:load', function (event) { run(event.target); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

